import { apiDelete, apiGet, apiPatch, apiPost } from './http-client';

export type RepresentedMinorItem = {
  id: number;
  user_id?: number;
  /** Имя ребёнка: одно или два слова. */
  name: string;
  date_of_birth: string;
  consent_version?: number;
  consent_accepted_at?: string | null;
  /** client_app | staff_offline | legacy */
  consent_source?: string | null;
  created_at?: string;
};

export type CreateMinorBody = {
  name: string;
  date_of_birth: string;
  /** Согласие законного представителя на обработку данных ребёнка (обязательно). */
  consent: boolean;
};

export type PatchMinorBody = {
  name?: string;
  date_of_birth?: string;
};

/** GET /api/v1/auth/me/minors */
export function listMyMinors(accessToken: string): Promise<RepresentedMinorItem[]> {
  return apiGet<RepresentedMinorItem[]>('/api/v1/auth/me/minors', undefined, { accessToken });
}

/** POST /api/v1/auth/me/minors */
export function createMyMinor(accessToken: string, body: CreateMinorBody): Promise<RepresentedMinorItem> {
  return apiPost<RepresentedMinorItem>('/api/v1/auth/me/minors', body, { accessToken });
}

/** PATCH /api/v1/auth/me/minors/{minor_id} */
export function patchMyMinor(accessToken: string, minorId: number, body: PatchMinorBody): Promise<RepresentedMinorItem> {
  return apiPatch<RepresentedMinorItem>(`/api/v1/auth/me/minors/${minorId}`, body, { accessToken });
}

/** DELETE /api/v1/auth/me/minors/{minor_id} */
export async function deleteMyMinor(accessToken: string, minorId: number): Promise<void> {
  await apiDelete<void>(`/api/v1/auth/me/minors/${minorId}`, { accessToken });
}
